import { TypographyP } from '@talentmesh/ui/components/typography';
import { ReactNode } from 'react';

interface PaymentSectionProps {
    header: string;
    actionComponent?: ReactNode;
    children: ReactNode;
}

const PaymentSection = ({ header, actionComponent, children }: PaymentSectionProps) => {
    return (
        <div className="flex flex-col">
            <div className="flex flex-row justify-between">
                <TypographyP className="mb-2.5 font-medium">{header}</TypographyP>
                {actionComponent}
            </div>
            {children}
        </div>
    );
};

export default PaymentSection;
